export default function () {
    return {
        languagesIsOpen: false,
        lastScroll: 0,
        refs: {
            body: document.body
        },

        classes: {
            successPage: 'checkout-onepage-success',
            scrollUp: 'scroll-up',
            scrollDown: 'scroll-down'
        },

        init() {
            this.setupWatchers();
            this.setupListeners();
            this.acquisitionType();
        },

        isMobile() {
            return this.$store.mq.isMobile();
        },

        setupWatchers() {
            this.$watch('isMobile()', () => {
                this.makeHeaderSticky(this.isMobile());
            });
        },

        setupListeners() {
            window.addEventListener('scroll', () =>
                this.makeHeaderSticky(this.isMobile())
            );
        },

        makeHeaderSticky(isMobile) {
            if (!isMobile) {
                this.refs.body.classList.remove(this.classes.scrollUp);
                this.refs.body.classList.remove(this.classes.scrollDown);
                this.lastScroll = 0;
                return;
            }

            const currentScroll = window.scrollY;

            if (currentScroll <= 0) {
                this.refs.body.classList.remove(this.classes.scrollUp);
                return;
            }
            if (
                currentScroll > this.lastScroll &&
                !this.refs.body.classList.contains(this.classes.scrollDown)
            ) {
                this.refs.body.classList.remove(this.classes.scrollUp);
                this.refs.body.classList.add(this.classes.scrollDown);
            } else if (
                currentScroll < this.lastScroll &&
                this.refs.body.classList.contains(this.classes.scrollDown)
            ) {
                this.refs.body.classList.remove(this.classes.scrollDown);
                this.refs.body.classList.add(this.classes.scrollUp);
            }
            this.lastScroll = currentScroll;
        },

        acquisitionType() {
            const url = new URL(window.location.href);

            if (url.searchParams.has('utm_source')) {
                let expirationDate = new Date();
                expirationDate.setHours(expirationDate.getHours() + 1);

                document.cookie =
                    'product_utm_source=' +
                    encodeURIComponent(url.searchParams.get('utm_source')) +
                    '; expires=' +
                    expirationDate.toUTCString() +
                    '; path=/';
            }
        },

        checkWindowSize() {
            if (window.innerWidth >= 1024) {
                this.languagesIsOpen = false;
            }
        },

        copyToClipboard(text) {
            navigator.clipboard.writeText(text);
        },

        mounted() {
            window.addEventListener('resize', this.checkWindowSize);
        },

        destroyed() {
            window.removeEventListener('resize', this.checkWindowSize);
        }
    };
}
